import React from 'react';
import { InventorySyncTemplate } from 'themes/modules/product-inventory/pages';
import { InventorySyncPageViewStore } from 'modules/product-inventory/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new InventorySyncPageViewStore(rootStore), 'inventorySyncPageViewStore')
class InventorySync extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <InventorySyncTemplate {...this.props} />;
	}
}

export default InventorySync;
